import * as React from "react";
import { View, TextInput, StyleSheet } from "react-native";
import MiniScooter from "@assets/svg/CpDeliveryBoys/mini_scooter";
import Text from "@components/CustomText";
import { colors } from "@utils/styles";
import { addCpDb } from "@services/api";
import BottomButton from "@screens/MyDeliveries/SortingDeliveries/components/BottomButton";
import Button from "@components/Button";
import t from "@constants/localization";

const AddDeliveryBoy = ({ setShowAddDbModal, fetchData, isModal = true }) => {
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [name, setName] = React.useState("");

  const onPressAddDeliveryBoy = async () => {
    if (phoneNumber && name) {
      try {
        const { data } = await addCpDb({
          phone_number: phoneNumber,
          name: name.trim(),
        });
        fetchData && fetchData(data?.data[0] || {});
      } catch (error) {
        console.log(error);
      } finally {
        setShowAddDbModal && setShowAddDbModal(false);
      }
    }
  };

  const PATH = "screens/CpDeliveryBoys/allDeliveryBoy";

  return (
    <View style={isModal ? styles.container : styles.constainer2}>
      <View style={styles.header}>
        <MiniScooter />
        <Text variant="body_text_4" style={styles.headerText}>
          {t(`${PATH}/headerTitle`)}
        </Text>
      </View>
      <View style={styles.inputContainer}>
        <TextInput
          testID="adb-phone-number"
          value={phoneNumber}
          maxLength={10}
          placeholder={t(`${PATH}/phonePlaceholder`)}
          keyboardType="numeric"
          onChangeText={(phoneNumberTxt) => {
            setPhoneNumber(phoneNumberTxt);
          }}
          style={styles.input}
        />
        <TextInput
          testID="adb-name"
          placeholder={t(`${PATH}/namePlaceholder`)}
          value={name}
          keyboardType="visible-password"
          onChangeText={(nameTxt) => {
            setName(nameTxt);
          }}
          style={[styles.input, styles.inputMargin]}
        />
      </View>

      {isModal ? (
        <>
          <View style={styles.bottomSpace} />
          <BottomButton
            title={t(`${PATH}/modalBottomButton`)}
            onPress={onPressAddDeliveryBoy}
          />
        </>
      ) : (
        <View style={{ paddingHorizontal: 16, paddingBottom: 10, top: -10 }}>
          <Button
            btnText={t(`${PATH}/bottomButton`)}
            onPress={onPressAddDeliveryBoy}
            buttonColor={colors.green1}
            buttonWidth="100%"
            buttonStyle={{ borderRadius: 10 }}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  constainer2: {
    backgroundColor: "#fff",
    borderRadius: 16,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
    paddingBottom: 0,
  },
  headerText: {
    marginLeft: 12,
  },
  inputContainer: {
    padding: 20,
  },
  input: {
    borderWidth: 1,
    borderColor: colors.gray4,
    borderRadius: 4,
    padding: 10,
    marginBottom: 10,
  },
  inputMargin: {
    marginTop: 10,
  },
  bottomSpace: {
    height: 60,
  },
});

export default AddDeliveryBoy;
